// istanbul ignore file - this file is not covered by tests as it is not to be released post alpha testing
import { useQueryParams } from '@calendly/hooks';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { Layout } from '@calendly/ui/components/layout';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { BodyText } from '@calendly/ui/components/typography';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { setGetParams } from 'actions/core/navigation';
import { setForceSSEDisconnect, useForceSSEDisconnect } from '../sse_polling_state';
import { SSEConnectionBadge } from '../SSEConnectionBadge/SSEConnectionBadge';
const menuTriggerCss = "m1d7odnf";
const panelCss = "p1d71rh6";
const sectionsRowCss = "sxv0j7o";
const sectionLabelCss = "sb0mahg";
const livePageBadgeCss = "lm87rog";
const livePageDotCss = "lawi5ns";
const LivePageBadge: FC<{
  isLive: boolean;
}> = ({
  isLive
}) => <span className={livePageBadgeCss} data-live={String(isLive)}>
    {isLive && <span className={livePageDotCss} aria-hidden />}
    {isLive ? 'Live' : 'Static'}
  </span>;
const menuSpanCss = "m19dxgax";
export interface MeetingsDebugMenuProps {
  /**
   * When the meetings page is in "live" (realtime) mode, this is the SSE connection state.
   * When not in live mode or SSE is not running, pass undefined.
   */
  connectionState?: string | null;
}

/**
 * alpha testing menu for the meetings page: connection state, force-disconnect toggle,
 * and live=? query param toggle. Only render when the realtime feature flag is on.
 * See MeetingsDebugMenu/README.md.
 */
export const MeetingsDebugMenu: FC<MeetingsDebugMenuProps> = ({
  connectionState
}) => {
  const dispatch = useDispatch();
  const queryParams = useQueryParams();
  const isLive = queryParams?.live !== '0';
  const forceSSEDisconnect = useForceSSEDisconnect();
  const [toggle, Dropdown, isOpen] = useDropdown();
  const handleToggleLive = (_e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setGetParams({
      live: isLive ? '0' : null
    }) as any);
  };
  const handleToggleForceDisconnect = (_e: React.ChangeEvent<HTMLInputElement>) => {
    setForceSSEDisconnect(!forceSSEDisconnect);
  };
  const effectiveConnectionState = forceSSEDisconnect ? 'error' : connectionState ?? null;
  return <span className={menuSpanCss} data-testid="meetings-debug-menu">
      <BareButton type="button" onClick={toggle} className={menuTriggerCss} aria-expanded={isOpen} aria-haspopup="true">
        alpha testing
      </BareButton>
      <Dropdown>
        <Layout direction="column" gap={8} className={panelCss}>
          <BodyText size="small" color="muted">
            RTUX alpha testing only. To be removed before launch.
          </BodyText>

          <Layout gap={8} className={sectionsRowCss}>
            <Layout direction="column" gap={4} align="center">
              <span className={sectionLabelCss}>Live page</span>
              <label>
                <SwitchInput checked={isLive} onChange={handleToggleLive} data-testid="meetings-debug-menu-toggle-live" aria-label="Live page" />
              </label>
              <LivePageBadge isLive={isLive} />
            </Layout>

            <Layout direction="column" gap={4} align="center">
              <span className={sectionLabelCss}>SSE connection</span>
              {connectionState != null || isLive ? <>
                  <label>
                    <SwitchInput checked={!forceSSEDisconnect} onChange={handleToggleForceDisconnect} data-testid="meetings-debug-menu-toggle-sse" aria-label="SSE connection" />
                  </label>
                  <SSEConnectionBadge connectionState={effectiveConnectionState} isVisible />
                </> : <BodyText size="small" color="muted">
                  Enable live page to see SSE state.
                </BodyText>}
            </Layout>
          </Layout>
        </Layout>
      </Dropdown>
    </span>;
};

require("./MeetingsDebugMenu.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingsDebugMenu.tsx");